import { useState } from "react";

const StudentImport = () => {
  const [studentType, setStudentType] = useState("1"); // default: Retail
  const [selectedFile, setSelectedFile] = useState(null);
  const [showDialog, setShowDialog] = useState(false);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleTypeChange = (e) => {
    setStudentType(e.target.value);
  };

  const handleSubmit = () => {
    if (!selectedFile) {
      alert("Please select a file!");
      return;
    }
    setShowDialog(true);
  };

  const confirmImport = () => {
    setShowDialog(false);
    alert(`File ready to import for type ${studentType}`);
  };

  const cancelImport = () => {
    setShowDialog(false);
  };

  return (
    <div>
      <h6 style={{ 
  borderBottom: "1px solid #4d3d6c", 
  width: "100%", 
  paddingBottom: "5px", 
  margin: 0 
}}
className="text-start fw-bold">Import Student </h6>
<div
  className="container border p-3 d-flex flex-column align-items-center w-75 mt-4 "
  style={{
    boxShadow: "0 0 10px 2px rgba(173, 216, 230, 0.6)", // light blue glow
    borderRadius: "8px", // optional rounded corners
    border: "1px solid #add8e6", // light blue border
  }}
><div className="container-fluid border d-flex align-items-center gap-5 mt-2 p-4 rounded ">
  <label className="d-flex align-items-center rounded "style={{fontSize:'13px'}}>
    <input
      type="radio"
      name="studentType"
      value="1"
      checked={studentType === "1"}
      onChange={handleTypeChange}
      className="me-1"
    />
    Retail Student
  </label>

  <label className="d-flex align-items-center"style={{fontSize:'13px'}}>
    <input
      type="radio"
      name="studentType"
      value="3"
      checked={studentType === "3"}
      onChange={handleTypeChange}
      className="me-1"
    />
    College Student
  </label>

  <label className="d-flex align-items-center"style={{fontSize:'13px'}}>
    <input
      type="radio"
      name="studentType"
      value="5"
      checked={studentType === "5"}
      onChange={handleTypeChange}
      className="me-1"
    />
    Government Entity Student
  </label>
</div>

<div className="container border mt-3 rounded">
     <div className=" mt-3 mb-4" style={{ 
  borderBottom: "1px solid #7d7b80ff", 
  width: "100%", 
  paddingBottom: "5px", 
  margin: 0 
}}> 
      <div className="container-fluid mt-3 mb-2 " style={{ gap: "100px" }}>
  <label style={{ fontSize: "13px" }}>
    Choose File: <span style={{ color: "red" }}>*</span>
  </label>

  <input
    style={{ fontSize: "11px", marginLeft:"70px"}}
    type="file"
    onChange={handleFileChange}
  />


  <a className="text-end"style={{marginLeft:'200px',textDecoration:'none',fontSize:'12px'}}
    href="CTEPLStudentImportWIC.php?strEventID=6"
    target="_blank"
    rel="noopener noreferrer"
  >
    Download Template
  </a>

</div>
</div>

  <div className=" container text-center ">
    <button className="btn border" style={{background:'#B2BEB5'}} onClick={handleSubmit}>Import</button>
</div>
<div
  style={{
    marginTop: "15px",
    padding: "10px 15px",

    fontSize: "13px",
  }}
>
  <p style={{ marginBottom: "5px", fontWeight: "bold" }}>Note:</p>
  <ol style={{ paddingLeft: "20px", margin: 0 }}>
    <li>Student Name and Parent Name will not update during edit</li>
    <li>
      Please select ID Proof type from below to fill in excel
      <ol type="1" style={{ paddingLeft: "20px", marginTop: "5px" }}>
        <li>10th Board Hall Ticket</li>
        <li>Bank Passbook</li>
        <li>BPL Card</li>
        <li>Current College ID</li>
        <li>Driving License</li>
        <li>PAN Card</li>
        <li>Learner Code</li>
        <li>Passport</li>
        <li>Photo ID issued by Post Office</li>
        <li>Ration Card</li>
        <li>Voter ID</li>
      </ol>
    </li>
  </ol>
</div>
</div>

      {showDialog && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              minWidth: "300px",
            }}
          >
            <p>
              You are about to register student under{" "}
              <strong>
                {studentType === "1"
                  ? "Retail"
                  : studentType === "3"
                  ? "College"
                  : "Government"}
              </strong>
              .
            </p>
            <p>Do you want to continue?</p>
            <button onClick={confirmImport} style={{ marginRight: "10px" }}>
              Yes
            </button>
            <button onClick={cancelImport}>No</button>
          </div>
        </div>
      )}
      </div>
    </div>
  );
};

export default StudentImport;
